import Alpine from "alpinejs";
import matchHeights from "@paintface_danny/alpine-match-heights";
import persist from "@alpinejs/persist";
import sliders from "./sliders";
import Render from "./render";
import collapse from "@alpinejs/collapse";
import tracking from "./tracking";
import loginTracking from "./login-tracking";

document.addEventListener("DOMContentLoaded", function () {
	window.dataLayer = window.dataLayer || [];

	window.Alpine = Alpine;
	Alpine.plugin(collapse);
	Alpine.plugin(matchHeights);
	Alpine.plugin(persist);
	Alpine.start();

	sliders();

	new Render();

	tracking();
	loginTracking();
	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + ((Math.random() * 0xffffff) << 0).toString(16);
	// });
});
